import EditorBannerType from "../../../types/EditorBannerType";
import { BannerActionKey } from "../../actions/ActionKeys";
import { BannersAction } from "../../actions/banners";

export const dismissedBanners = (
  state: EditorBannerType[] = [],
  action: BannersAction
) => {
  switch (action.type) {
    case BannerActionKey.DISMISS_BANNER:
      if (!state.includes(action.payload.banner)) {
        return state.concat(action.payload.banner);
      } else {
        return state;
      }
    default:
      return state;
  }
};
